import React, { useState } from 'react'
import './stock-search-filter.scss'
import { Row, Expaned } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'
import FilterContainer from '../../../components/filter-container/filter-container'
import Iconfont from '@/components/iconfont/iconfont'
import { showLayer } from '@/utils/layer'
import { ChooseGoodsCategoryDialog } from '../../../goods-storage/goods-library/modules/edit-goods/modules/goods-category/goods-category'
import { goodsModel, IGoodsCategory } from '../../../goods-storage/goods-library/modules/edit-goods/modules/model'
import { stockSearchFilterStore } from './filter-store'
import GroupPopover from '../../../components/group-popover/group-popover'

interface StockSearchFilterProps {
    onCancel: () => void
}

const StockSearchFilter: React.FC<StockSearchFilterProps> = props => {
    const cls = useBemClass('stock-search-filter')
    const [category, setCategroy] = useState<IGoodsCategory | null>(stockSearchFilterStore.category)
    const [group, setGroup] = useState<number[]>([])
    const [name, setName] = useState<string>(stockSearchFilterStore.groupName)

    return (
        <FilterContainer
            onConfirm={() => {
                stockSearchFilterStore.setCategory(category)
                stockSearchFilterStore.setGroup(group, name)
                props.onCancel()
            }}
            onCancel={props.onCancel}
            onReset={() => {
                setCategroy(null)
                setGroup([])
                setName('')
            }}
        >
            <Row data-width-100p data-align-items-center data-height-50 data-margin-bottom-10>
                <Expaned data-row data-align-items-center className={cls('line')}>
                    <div data-color-999 data-font-size-14 data-margin-right-40>
                        类目筛选
                    </div>
                    <div
                        className={cls('ipt')}
                        onClick={() => {
                            showLayer(
                                <ChooseGoodsCategoryDialog
                                    goodsModel={goodsModel}
                                    onChange={c => {
                                        setCategroy(c)
                                    }}
                                />,
                            )
                        }}
                    >
                        {category?.name ? <div>{category?.name}</div> : <div data-color-999>请选择类目</div>}
                        <Iconfont name="icon6youjiantou-20" size={14} />
                    </div>
                </Expaned>
                <Expaned data-row data-align-items-center data-margin-left-26>
                    <div data-color-999 data-font-size-14 data-margin-right-40>
                        分组筛选
                    </div>
                    <Expaned>
                        <GroupPopover
                            onConfirm={(g, s, n) => {
                                setGroup([g, s])
                                setName(n)
                            }}
                        >
                            <div data-width-100p className={cls('ipt')}>
                                {name ? <div>{name}</div> : <div data-color-999>请选择分组</div>}

                                <Iconfont name="icon6youjiantou-20" size={14} />
                            </div>
                        </GroupPopover>
                    </Expaned>
                </Expaned>
            </Row>
        </FilterContainer>
    )
}

export default StockSearchFilter
